import React from 'react';
import {
  TextField,
  NumberField,
  ListBase,
  ListToolbar,
  Pagination,
  Title,
  useListContext,
  Datagrid,
} from 'react-admin';
import { useHistory } from 'react-router-dom';

import { Card } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';

import Actions from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { stringify, STATUS_ATIVO } from '../../utils';

//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_IMPOSTOS_LISTAR } from '../../utils/dadosTelas';
import Filter from './Filter';

//
const MyList = ({ ...props }) => {
  const history = useHistory();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;

  function handleTransacoesEspeciais({ tipo_transacao_especial }) {
    const queryOj = {};

    queryOj.displayedFilters = JSON.stringify({
      tipo: true,
      status: true,
      periodo: true,
    });

    queryOj.filter = JSON.stringify({
      tipo: tipo_transacao_especial,
      status: STATUS_ATIVO,
      periodo: filterValues.periodo,
    });

    history.push(
      `/transacoes_especiais?${stringify(
        queryOj,
      )}&order=DESC&page=1&perPage=50&sort=data`,
    );
  }

  return (
    <>
      <Title title="Contas Especiais" />
      <ListToolbar
        filters={props.filters}
        actions={<Actions {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="nome" label="Descrição" />
          <NumberField
            sortable={false}
            source="valor"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: 'currency',
              currency: 'BRL',
            }}
            label="Saldo"
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            //handleTransacoesEspeciais={handleTransacoesEspeciais}
            actions={[
              {
                key: 'transacoes',
                title: 'Lista dos Impostos',
                icon: <ListIcon />,
                onClick: (rec) => handleTransacoesEspeciais(rec),
                show: (rec) => true,
                disabled: (rec) => false,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10]} {...props} />
);

const List = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_IMPOSTOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Contas Especiais"
      filterDefaultValues={{
        periodo: {
          start: new Date(),
          end: new Date(),
        },
      }}
      component="div"
    />
  </ProtegerPagina>
);

export default List;
